// extracted by mini-css-extract-plugin
export var white = "empty-screen-module--white--09cee";
export var wrapper = "empty-screen-module--wrapper--392a7";